import { processingSessionItemIdFormat } from "@redotech/redo-ids/ids";
import { SortDispositionSchema } from "@redotech/redo-model/wms/schema/sort-disposition";
import { SortDestinationForeground } from "@redotech/redo-model/wms/sort-destination-display";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const SortDestinationDisplaySchema = z.object({
  label: z.string(),
  color: z.string(),
  foreground: z.enum([
    SortDestinationForeground.light,
    SortDestinationForeground.dark,
  ]),
});
export type SortDestinationDisplay = z.infer<
  typeof SortDestinationDisplaySchema
>;

export const getProcessingSessionSortDestinations = {
  name: "getProcessingSessionSortDestinations" as const,
  input: z.object({
    returnId: zExt.objectId(),
    // Identifies the operator's station so the per-item destination reflects the
    // bound tote completion will route into. Absent falls back to
    // single-open-session-at-location detection (same as completion).
    workstationId: z.string().optional(),
  }),
  output: z.object({
    sessionDestination: SortDestinationDisplaySchema.nullable(),
    itemDestinations: z.record(
      processingSessionItemIdFormat.schema,
      SortDestinationDisplaySchema.nullable(),
    ),
    unboundDisposition: SortDispositionSchema.nullable(),
  }),
};
